// The model only needs 224px. Capping the output keeps full-resolution phone
// photos under iOS Safari's canvas size and memory limits.
const MAX_OUTPUT_SIDE = 1024;

export const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.setAttribute("crossOrigin", "anonymous");
    image.src = url;
  });

export const getCroppedImgDataURL = async (imageSrc, crop) => {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  const scale = Math.min(1, MAX_OUTPUT_SIDE / Math.max(crop.width, crop.height));
  canvas.width = Math.max(1, Math.round(crop.width * scale));
  canvas.height = Math.max(1, Math.round(crop.height * scale));
  ctx.imageSmoothingQuality = "high";

  ctx.drawImage(
    image,
    crop.x,
    crop.y,
    crop.width,
    crop.height,
    0,
    0,
    canvas.width,
    canvas.height
  );

  const dataURL = canvas.toDataURL("image/png");
  // iOS holds on to canvas memory until the canvas is shrunk
  canvas.width = 0;
  canvas.height = 0;
  return dataURL;
};
